import { Component, OnInit } from '@angular/core';


@Component({
    standalone: false,
    selector: 'lib-client-file-manager-toolbar',
  templateUrl: './client-file-manager-toolbar.component.html',
  styleUrls: ['./file-manager-toolbar.component.scss']
})
export class ClientFileManagerToolbarComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
